<template>
  <v-container id="reference-term-list">
    <v-row>
      <v-col cols="8" md="8" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>

      <v-col cols="4" sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-upload :dialog="false"> </app-modal-upload>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="separator-list">
        <v-divider></v-divider>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <app-group-solution-combobox
          :filter="filter"
          @changeGroupSolution="reloadSolutions()"
        ></app-group-solution-combobox>
      </v-col>
      <v-col>
        <app-solution-combobox
          :filter="filter"
          @changeSolution="reloadTasks()"
        ></app-solution-combobox>
      </v-col>
      <v-col>
        <app-task-combobox
          :filter="filter"
          @changeTask="reloadEvidences()"
        ></app-task-combobox>
      </v-col>
    </v-row>

    <v-row>
      <v-tabs vertical>
        <v-tab>
          <v-icon left>mdi-domain</v-icon>
          Projetos
        </v-tab>
        <v-tab>
          <v-icon left>mdi-axis-arrow</v-icon>
          Grupos de Solução
        </v-tab>
        <v-tab>
          <v-icon left>mdi-beaker-outline</v-icon>
          Soluções
        </v-tab>
        <v-tab>
          <v-icon left>mdi-calendar-check-outline</v-icon>
          Tarefas
        </v-tab>
        <v-tab>
          <v-icon left>mdi-book-search-outline</v-icon>
          Evidências
        </v-tab>

        <v-tab-item>
          <v-col>
            <app-project-list></app-project-list>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <v-col>
            <app-group-solution-list :filter="filter"></app-group-solution-list>
          </v-col>
        </v-tab-item>
        <v-tab-item>
          <app-solution-list
            ref="solutionList"
            :filter="filter"
            :solutions="filter.solutions"
            @reloadSolutions="loadSolutions()"
          ></app-solution-list>
        </v-tab-item>
        <v-tab-item>
          <app-task-list
            :filter="filter"
            :tasks="filter.tasks"
            @onSaveTask="reloadEvidences"
            @reloadTasks="loadTasks()"
          ></app-task-list>
        </v-tab-item>
        <v-tab-item>
          <app-evidence-list
            :filter="filter"
            :evidences="filter.evidences"
            @onDeleteEvidence="reloadTasks"
            @reloadEvidences="loadEvidences()"
          ></app-evidence-list>
        </v-tab-item>
      </v-tabs>
    </v-row>
  </v-container>
</template>

<script>
import AppProjectList from "@/modules/project/components/List";
import AppGroupSolutionList from "@/modules/group-solution/components/List";
import AppSolutionList from "@/modules/solution/components/List";
import AppTaskList from "@/modules/task/components/List";
import AppEvidenceList from "@/modules/evidence/components/List";
import { AppGroupSolutionCombobox } from "@/modules/group-solution";
import { AppSolutionCombobox, solutionAPI } from "@/modules/solution";
import { AppTaskCombobox, taskAPI } from "@/modules/task";
import { evidenceAPI } from "@/modules/evidence";
import { mapActions, mapGetters } from "vuex";
import { AppModalUpload } from "@/modules/reference-term";

export default {
  components: {
    AppProjectList,
    AppGroupSolutionList,
    AppSolutionList,
    AppTaskList,
    AppEvidenceList,
    AppGroupSolutionCombobox,
    AppSolutionCombobox,
    AppTaskCombobox,
    AppModalUpload,
  },
  data() {
    return {
      headers: [
        {
          text: "#",
          sortable: false,
        },
        {
          text: "Nome",
          align: "left",
          sortable: false,
          value: "name",
        },
        { text: "Plano", value: "calories" },
        { text: "Carga Horária", value: "fat" },
      ],
      payload: {},
      breadcrumbs: [
        {
          text: "Gestão de Termos de Referência",
          disabled: true,
          href: "termo-referencia",
        },
      ],
      filter: {
        grupoSolucaoId: 0,
        solucaoId: 0,
        tarefaId: 0,
        evidenciaId: 0,
        solutions: [],
        tasks: [],
        evidences: [],
      },
      solutions: [],
      tasks: [],
      evidences: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    reloadSolutions() {
      this.filter.solucaoId = 0;
      if (this.filter.grupoSolucaoId) {
        this.filter.solutions = this.solutions.filter((i) => {
          return i.grupoSolucaoId === this.filter.grupoSolucaoId;
        });
      } else {
        this.filter.solutions = this.solutions;
      }
    },
    loadSolutions() {
      this.setLoading(true);
      solutionAPI
        .list()
        .then((resp) => {
          this.solutions = resp.data;
          this.filter.solutions = resp.data;
          this.reloadSolutions();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar soluções");
        });
    },
    reloadTasks() {
      this.setLoading(true);
      this.filter.tarefaId = 0;
      if (this.filter.solucaoId) {
        this.filter.tasks = this.tasks.filter((i) => {
          return i.solucaoId === this.filter.solucaoId;
        });
      } else {
        this.filter.tasks = this.tasks;
      }
      this.reloadEvidences();
    },
    loadTasks() {
      this.setLoading(true);
      taskAPI
        .list()
        .then((resp) => {
          this.tasks = resp.data;
          this.filter.tasks = resp.data;
          this.reloadTasks();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar tarefas");
        });
    },
    reloadEvidences() {
      this.setLoading(true);
      this.filter.evidenciaId = 0;
      if (this.filter.tarefaId) {
        this.filter.evidences = this.evidences.filter((i) => {
          return i.tarefaId === this.filter.tarefaId;
        });
      } else {
        this.filter.evidences = this.evidences;
      }
      this.setLoading(false);
    },
    loadEvidences() {
      this.setLoading(true);
      evidenceAPI
        .list()
        .then((resp) => {
          this.evidences = resp.data;
          this.filter.evidences = resp.data;
          this.reloadEvidences();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar evidências");
        });
    },
  },
  mounted() {
    this.loadSolutions();
    this.loadTasks();
    this.loadEvidences();
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
    ]),
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
